import { Avatar, AvatarShape, Space, Text } from 'farmhub-ui-core';

import { WrapperMobile, WrapperAvatarMobile } from './styles';

interface EntityCardProps {
  onClick: (e: any) => void;
  item: any;
}

const EntityCardMobile = ({ item, onClick }: EntityCardProps): JSX.Element => (
  <WrapperMobile onClick={onClick}>
    <WrapperAvatarMobile background={item.background}>
      <Avatar shape={AvatarShape.Square} size={38} src={item.avatar} />
    </WrapperAvatarMobile>
    <Space height={18} />
    <Text size="xs" styles={{ textAlign: 'center' }} weight="extraBold">
      {item.name}
    </Text>
  </WrapperMobile>
);

export default EntityCardMobile;
